import React, { Fragment, useEffect, useState } from 'react'
import EmptyTeamCard from './_Components/EmptyTeamCard'
import AddTeamMembers from './Add'
import ListTeamMembers from './List'

import { Spinner } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { alertActions } from '../../../../../_actions/alert.actions'
import { usersService } from '../../../../../_services/users.service'

export default function TeamMembers({ user }) {
  const dispatch = useDispatch(null)
  const [loading, setLoading] = useState(true)
  const [teamMembers, setTeamMembers] = useState(null)
  const [addTeamMembers, setAddTeamMembers] = useState(false)

  useEffect(() => {
    usersService.getTeamMembers(user.licensedId)
      .then((response) => {
        if (response && response.data) {
          setTeamMembers(response.data.data)
        }
      })
      .catch(() => {
        dispatch(alertActions.error('Could not retrieve team members at this time. Please try again.'));
      })
      .then(() => {
        setLoading(false)
      })
  }, [dispatch, user.licensedId])

  const reloadData = () => {
    usersService.getTeamMembers(user.licensedId)
      .then((response) => {
        if (response && response.data) {
          setTeamMembers(response.data.data)
          setAddTeamMembers(false)
        }
      })
      .catch(() => {
        dispatch(alertActions.error('Could not retrieve team members at this time. Please try again.'));
      })
  }

  if (loading) {
    return <Spinner animation='border'/>
  }

  return (
    <Fragment>
      { addTeamMembers && 
        <AddTeamMembers
          user={user} 
          handleBack={reload => {
            if (reload) {
              reloadData()
            } else {
              setAddTeamMembers(false)
            }
          }}
        />
      }
      
      { teamMembers.length > 0 && !addTeamMembers && 
        <ListTeamMembers 
          user={user}
          handleReload={reloadData}
          teamMembers={teamMembers}
          handleShowAddToTeam={() => setAddTeamMembers(true)} 
        />
      }

      { teamMembers.length === 0 && !addTeamMembers && 
        <EmptyTeamCard handleShowAddToTeam={() => setAddTeamMembers(true)}/>
      }
    </Fragment>
  )
}
